import React from "react";
import { TableRow } from "@material-ui/core";

import { DealCountWithTooltip, EmailStatusConfig } from "..";

import {
  StyledTable,
  StyledTableHead,
  StyledTableHeadCell,
  StyledTableBody,
  StyledBodyTableRow,
  SpacerCell,
  StyledBodyTableCell
} from "./styles";

const EmailRecipientDetailsTable = ({
  clientViewIsVisible,
  contactColumnNameTitle,
  contactColumnEmailTitle,
  emailRecipientData
}) => {
  const determineEmailStatusMessage = emailStatusId => EmailStatusConfig[emailStatusId].label;
  const determineEmailStatusMessageColor = emailStatusId => EmailStatusConfig[emailStatusId].color;
  const determineContactName = (contact = {}) => (clientViewIsVisible ? contact?.contactName : contact?.brokerContactName);
  const determineEmailAddress = (contact = {}) => (clientViewIsVisible ? contact?.contactEmail : contact?.brokerContactEmail);

  return (
    <StyledTable>
      <StyledTableHead>
        <TableRow>
          <SpacerCell />
          <StyledTableHeadCell>Company Name</StyledTableHeadCell>
          <StyledTableHeadCell>{contactColumnNameTitle}</StyledTableHeadCell>
          <StyledTableHeadCell>{contactColumnEmailTitle}</StyledTableHeadCell>
          <StyledTableHeadCell>Deal Count</StyledTableHeadCell>
          <StyledTableHeadCell>Email Status</StyledTableHeadCell>
        </TableRow>
      </StyledTableHead>
      <StyledTableBody>
        {
          emailRecipientData.map((row, index) =>
            <StyledBodyTableRow key={`${row.id}-${index}`}>
              <SpacerCell />
              <StyledBodyTableCell>{row.companyName}</StyledBodyTableCell>
              <StyledBodyTableCell>{determineContactName(row.contact)}</StyledBodyTableCell>
              <StyledBodyTableCell>{determineEmailAddress(row.contact)}</StyledBodyTableCell>
              <StyledBodyTableCell center>
                <DealCountWithTooltip
                  label={row.deals.length.toString()}
                  titles={row.deals.map(({ name }) => name)}
                />
              </StyledBodyTableCell>
              <StyledBodyTableCell color={() => (row.emailStatus ? determineEmailStatusMessageColor(row.emailStatus) : "")}>
                {row.emailStatus ? determineEmailStatusMessage(row.emailStatus) : null}
              </StyledBodyTableCell>
            </StyledBodyTableRow>
          )
        }
      </StyledTableBody>
    </StyledTable>
  );
};

export default EmailRecipientDetailsTable;
